<div>
  <app-side-card
    id="client-information-main-card"
    [title]="title"
    [subtitle]="subtitle"
    [linkText]="urlDisplayText"
    [linkDestination]="url"
    *ngIf="!isVertialOrientation"
    [height]="300"
  >
    <app-client-information-entry
      *ngFor="let attribute of attributes; index as i"
      [id]="attribute.display"
      [key]="attribute.display"
      [value]="attribute.value"
      [placeholder]="attribute.placeholder"
      [borders]="getBorder(i)"
    />
  </app-side-card>

  <div *ngIf="isVertialOrientation" class="client-information-vertical-layout">
    <app-side-card
      id="client-information-side-card"
      [title]="title"
      [subtitle]="subtitle"
      [linkDestination]="url"
      [size]="large"
    >
      <table class="table-style">
        <tr>
          <th
            *ngFor="let attribute of attributes; index as i"
            class="table-align-text"
            translate
          >
            {{ attribute.display }}
          </th>
          <th class="table-align-text" *ngIf="hasLink()" translate>
            Quick View
          </th>
        </tr>
        <tr>
          <td
            *ngFor="let attribute of attributes; index as i"
            class="table-align-text"
          >
            {{
              attribute.value === '' ? attribute.placeholder : attribute.value
            }}
          </td>
          <td *ngIf="hasLink()">
            <app-link kind="standard" [destination]="url" color="accent">{{
              'Edit Profile' | translate
            }}</app-link>
          </td>
        </tr>
      </table>
    </app-side-card>
  </div>
</div>
